import { Component } from '@angular/core';

@Component({
standalone: false,
  selector: 'app-delegated-liability-started',
  styleUrls: ['./delegated-liability-started-dialog.component.scss'],
  templateUrl: './delegated-liability-started-dialog.component.html',
})
export class DelegatedLiabilityStartedDialogComponent {
  constructor() {}
}
